import * as _ from "lodash"
import { ServiceQuoteTravellerData } from "@requests"

export interface IHasQuoteTravellers {
    setQuoteTravellers(quoteTravellers: ServiceQuoteTravellerData[]): void
    getQuoteTravellers(): ServiceQuoteTravellerData[]
    getIsSelectedForTravellerId(id: string): boolean
    getIsSelectedForAny(): boolean
    getIsSelectedForAll(): boolean
    getIsIncludedForTravellerId(id: string): boolean | undefined
    getIsIncludedForAny(): boolean
    getIsIncludedForAll(): boolean
    getPriceForTravellerId(id: string): number | undefined
}

function hasQuoteTravellers<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasQuoteTravellers {
        protected _quoteTravellers: ServiceQuoteTravellerData[] = []

        constructor(...args: any[]) {
            super(...args);
        }

        public setQuoteTravellers(quoteTravellers: ServiceQuoteTravellerData[]): void {
            this._quoteTravellers = quoteTravellers
        }
        public getQuoteTravellers(): ServiceQuoteTravellerData[] {
            return this._quoteTravellers
        }

        public getIsSelectedForTravellerId(id: string): boolean {
            const obj = this._quoteTravellers?.find((obj: ServiceQuoteTravellerData) => {
                return obj.id === id
            })
            return Boolean(obj?.selected)
        }
        public getIsSelectedForAny(): boolean {
            return !!this._quoteTravellers?.find((obj: ServiceQuoteTravellerData) => {
                return obj.selected
            })
        }
        public getIsSelectedForAll(): boolean {
            let flag = true
            this._quoteTravellers?.forEach((obj: ServiceQuoteTravellerData) => {
                if (!obj.selected) flag = false
            })
            return flag
        }
        public getIsIncludedForTravellerId(id: string): boolean | undefined {
            const obj = this._quoteTravellers?.find((obj: ServiceQuoteTravellerData) => {
                return obj.id === id
            })
            return obj?.included
        }
        public getIsIncludedForAny(): boolean {
            return !!this._quoteTravellers?.find((obj: ServiceQuoteTravellerData) => {
                return obj.included
            })
        }
        public getIsIncludedForAll(): boolean {
            let flag = true
            this._quoteTravellers?.forEach((obj: ServiceQuoteTravellerData) => {
                if (!obj.included) flag = false
            })
            return flag
        }
        public getPriceForTravellerId(id: string): number | undefined {
            if (!this._quoteTravellers) return
            const obj = this._quoteTravellers.find((obj: ServiceQuoteTravellerData) => {
                return obj.id === id
            })
            const price = obj?.price
            if (!price) return
            return price
        }
    };
}

export default hasQuoteTravellers